import React from "react";
import { Box, Card, Text, Title } from "@mantine/core";
import { IconBell } from "@tabler/icons-react";
import moment from "moment";
import { decrypt } from "../../utils";
import useStyles from "./style";

const NotificationCard = ({ item }) => {
  const { classes } = useStyles();
  return (
    <>
      <Card radius={10} shadow="sm" className={classes.cardMargin}>
        <Box className={classes.cardContainer}>
          <IconBell className={classes.settingIcon} stroke={1} />
          <Box className={classes.date}>
            <Text className={classes.textMargin}>
              {moment(item?.metadata?.file?.expiry).format("MMM DD YYYY")}
            </Text>
            <Text className={classes.textMargin}>
              {moment(item?.metadata?.file?.expiry).format("hh:mm A")}
            </Text>
          </Box>
          <Box className={classes.message}>
            <Title order={3} className={classes.titleMargin}>
              {item?.module === "document" ? "Document Expiry" : ""}
            </Title>
            <Text className={classes.textMargin}>
              {/* your document is going to be expire tonight. */}
              Client <strong>{decrypt(item?.client?.name, false)}</strong>,
              {item?.title} {item?.message}
            </Text>
          </Box>
        </Box>
      </Card>
    </>
  );
};

export default NotificationCard;
